import { render, staticRenderFns } from "./PerformanceFeedback.vue?vue&type=template&id=88a38ab8&scoped=true&"
import script from "./PerformanceFeedback.vue?vue&type=script&lang=ts&"
export * from "./PerformanceFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a38ab8",
  null
  
)

export default component.exports